<template>
  <div @mouseleave="onMouseLeave">
    <nav>
      <div class="container">
        <ul class="flex items-center justify-center gap-x-7.5">
          <li v-for="link in navigation" :key="link.id" class="flex-shrink-0">
            <component
              :is="getComponentType(link)"
              :id="
                link.url.includes('btn-id-') ? extractButtonId(link.url) : null
              "
              :to="
                !link.is_title && !link.url.includes('btn-id-')
                  ? localePath(link.url)
                  : null
              "
              class="inline-flex text-xs uppercase"
              :class="[
                !link.is_title &&
                  'cursor-pointer underline-offset-4 hover:underline',
                menuOpened &&
                  activeMenu?.id === link.id &&
                  'underline underline-offset-4',
                Number(activeLink?.id) === link.id
                  ? 'underline underline-offset-4'
                  : '',
                (link.url === '/sale' || link.url === '/vault-sale') ? 'text-red-80' : 'text-primary',
              ]"
              :data-e2e-item="!link.is_title ? 'navigation' : null"
              @mouseenter="setActiveMenu(link)"
            >
              {{ link?.currentTranslation?.title }}
            </component>
          </li>
        </ul>
      </div>
    </nav>
    <teleport to="body">
      <transition
        enter-active-class="transition duration-150 ease-out"
        enter-from-class="opacity-0"
        enter-to-class="opacity-100"
        leave-active-class="transition duration-100 ease-out"
        leave-from-class="opacity-100"
        leave-to-class="opacity-0"
      >
        <div
          v-if="menuOpened"
          class="fixed left-0 right-0 top-[calc(var(--header-height)+var(--discount-compaign-visible-height))] z-[99999] max-h-[calc(100dvh-(var(--header-height)+var(--discount-compaign-visible-height)))] overflow-auto pt-px"
          @mouseenter="setActiveMenu(activeMenu)"
          @mouseleave="onMouseLeave"
        >
          <div class="flex w-full bg-white">
            <div class="container-left-margin">
              <div class="flex">
                <div
                  class="grid gap-10 pb-10 pt-7.5"
                  :class="sliderElement?.children?.length ? 'w-[40%] grid-cols-[repeat(3,minmax(100px,max-content))] 2xl:grid-cols-[repeat(4,minmax(100px,max-content))]' : 'w-full grid-cols-[repeat(6,minmax(100px,max-content))] 3xl:grid-cols-[repeat(8,minmax(100px,max-content))]'"
                >
                  <div v-for="link in filteredChildren" :key="link.id">
                    <component
                      :is="getComponentType(link)"
                      :id="
                        link.url.includes('btn-id-')
                          ? extractButtonId(link.url)
                          : null
                      "
                      :to="
                        !link.is_title && !link.url.includes('btn-id-')
                          ? localePath(link.url)
                          : null
                      "
                      class="mb-5 inline-flex text-xs uppercase text-orange-60"
                      :class="[
                        !link.is_title &&
                          'cursor-pointer underline-offset-4 hover:underline',
                      ]"
                      :data-e2e-item="!link.is_title ? 'navigation' : null"
                    >
                      <span v-html="link?.currentTranslation?.title" />
                    </component>
                    <ul class="space-y-3.5">
                      <li
                        v-for="link2 in link.children"
                        :key="link2.id"
                        class="text-xs font-light text-gray-100"
                      >
                        <component
                          :is="getComponentType(link2)"
                          :id="
                            link2.url.includes('btn-id-')
                              ? extractButtonId(link2.url)
                              : null
                          "
                          :to="
                            !link2.is_title && !link2.url.includes('btn-id-')
                              ? localePath(link2.url)
                              : null
                          "
                          class="inline-flex items-center gap-1.5"
                          :class="[
                            !link2.is_title &&
                              'cursor-pointer underline-offset-4 hover:underline',
                            Number(activeLink?.id) === link2.id
                              ? 'font-bold before:mr-1 before:inline-block before:size-2 before:rounded-full before:bg-orange-50'
                              : '',
                          ]"
                          :data-e2e-item="!link2.is_title ? 'navigation' : null"
                        >
                          <img
                            v-if="link2.image || link2.icon"
                            class="h-4 w-4 object-contain"
                            :src="link2.image || link2.icon"
                            :alt="link2?.currentTranslation?.title"
                          />
                          <span v-html="link2?.currentTranslation?.title" />
                        </component>
                      </li>
                    </ul>
                  </div>
                </div>
                <div v-if="sliderElement?.children?.length" class="h-fit w-[60%] pl-8">
                  <div class="max-lg:hidden">
                    <Swiper
                      :slides-per-view="3"
                      :loop="false"
                      :centered-slides="false"
                      :initial-slide="0"
                      :modules="modules"
                      class="w-full"
                      :breakpoints="{
                        [screens.md]: {
                          slidesPerView: 3,
                          centeredSlides: false,
                          initialSlide: 0,
                        },
                      }"
                    >
                      <SwiperSlide
                        v-for="item in sliderElement?.children?.slice(0, 15)"
                        :key="item.id"
                      >
                        <NuxtLink :to="item?.url || '/'">
                          <div
                            class="group relative flex h-full items-center justify-center bg-black"
                          >
                            <div class="h-full w-full cursor-pointer">
                              <UiLazyImg
                                class="h-full w-full opacity-90 transition-opacity duration-300 ease-out group-hover:opacity-100"
                                :src="item.image || ''"
                                :alt="item.currentTranslation?.title || 'image'"
                                img-classes="object-contain"
                                no-lazy
                              />
                            </div>
                            <div
                              class="absolute bottom-3 right-4 text-sm font-medium text-white underline-offset-2 group-hover:underline"
                              v-html="item.currentTranslation?.title || ''"
                            />
                          </div>
                        </NuxtLink>
                      </SwiperSlide>
                    </Swiper>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </teleport>
  </div>
</template>

<script setup lang="ts">
import type { NavMenuItem } from "ecom-types";
import { NuxtLink } from "#components";
import { Swiper, SwiperSlide } from "swiper/vue";
import { Navigation } from "swiper";
import { screens } from "~/configs/breakpointsConfig.json";
import { navigationConstants } from "~/configs";

const { headerMenu } = useGeneralStore();

const localePath = useLocalePathPolyfill();

const activeMenu = ref<TreeItem<NavMenuItem> | null>(null);
let timeout: ReturnType<typeof setTimeout>;

const navigation = computed(() => {
  return toTree(headerMenu);
});

const { findBreadcrumb } = useBreadcrumbs();

const route = useRoute();

watch(
  () => route.fullPath,
  () => {
    setActiveMenu(null);
  },
  {
    immediate: true,
  },
);

const menuOpened = computed(() => {
  return activeMenu.value && activeMenu.value.children?.length;
});

const activeLink = computed(() => {
  const breadcrumbs = findBreadcrumb(navigation.value, route);
  return breadcrumbs[breadcrumbs.length - 1];
});

const filteredChildren = computed(() =>
  activeMenu?.value?.children?.filter(
    (item) =>
      item.currentTranslation?.title.toLowerCase() !== navigationConstants.sliderElementsTitle,
  ),
);

const sliderElement = computed(() =>
  activeMenu?.value?.children?.find(
    (item) =>
      item.currentTranslation?.title.toLowerCase() === navigationConstants.sliderElementsTitle,
  ),
);

function onMouseLeave() {
  clearTimeout(timeout);
  timeout = setTimeout(() => {
    setActiveMenu(null);
  }, 350);
}

function setActiveMenu(item: TreeItem<NavMenuItem> | null) {
  clearTimeout(timeout);
  activeMenu.value = item;
}

function getComponentType(link: NavMenuItem) {
  if (link.is_title) {
    return "div";
  } else if (link.url.includes("btn-id-")) {
    return "button";
  } else {
    return NuxtLink;
  }
}

const modules = [Navigation];
</script>
